module.exports = __webpack_public_path__ + "img/hhq.105976bc.png";